import { App } from "antd";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  approveKycByClient,
  denyKycByClient,
  setDefaultPaperOpenAdd,
  setDefaultPaperSelected,
} from "store/bailiff/(default)/paper/default_paper.action";
import {
  defaultPaperAllSelector,
  defaultPaperSelectedSelector,
} from "store/bailiff/(default)/paper/default_paper.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
// kyc review.
export const useKycAdd = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const selected = useSelector(defaultPaperSelectedSelector);
  // -------------------------- FUNCTION ------------------------
  const handleOpenPreview = (data) => {
    dispatch(setDefaultPaperOpenAdd(true));
    dispatch(setDefaultPaperSelected(data));
  };

  const handleClosePreview = () => {
    dispatch(setDefaultPaperOpenAdd(false));
    dispatch(setDefaultPaperSelected(null));
  };

  const handleConfirmApprove = () => {
    if (!selected) return message.error("Client not found!");
    const client = selected?.client;
    setLoading(true);
    dispatch(
      approveKycByClient({ client }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success("Đã chấp nhận đơn kyc!");
          handleClosePreview();
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  const handleConfirmDeny = (form) => {
    form
      ?.validateFields()
      .then((values) => {
        if (!values) return message.error("Input not found!");
        if (!selected) return message.error("Client not found!");
        const reason = values?.reason;
        const client = selected?.client;
        if (!reason)
          return message.info("Làm ơn điền lý do trước khi hoàn tất!");
        setLoading(true);
        dispatch(
          denyKycByClient({ client, reason }, (res) => {
            setLoading(false);
            if (res?.status === 200) {
              message.success("Đã từ chối đơn kyc thành công!");
              handleClosePreview();
            }
            if (res?.status === 500) {
              message.error(res?.data);
            }
          }),
        );
      })
      .catch((err) => {
        console.log({ err });
      });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return {
    loading,
    handleOpenPreview,
    handleClosePreview,
    handleConfirmApprove,
    handleConfirmDeny,
  };
};

// kyc refine
export const useKycRefine = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(defaultPaperAllSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data };
};
